export const KNOW_MORE = "En savoir +";
export const SERVICES = "Services";
export const SEARCH_SKIP = 0;
export const SEARCH_LIMIT = 60;
export const TRAINING_SESSIONS_LIMIT = 6;
export const CONTENTIEUX = "contentieux";
export const TRACABILITE = "tracabilite";
export const JURIDIQUE = "juridique";
export const REGLEMENTATIONS = "reglementations";
